import React, {useEffect, useState} from 'react';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import {Box, CardActionArea, CardContent, Chip} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {getPostStatistic} from "../../http/postAPI";
import RequestAppointmentCounter from "../RequestAppointmentCounter";

const API_URL = process.env.REACT_APP_API_URL || window.API_URL;

const PostItem = ({post, route}) => {
    const navigate = useNavigate();

    const [postStatistic, setPostStatistic] = useState({});

    // Функция для удаления HTML-тегов и обрезки текста до 40 символов
    const getContentSnippet = (htmlContent) => {
        // Удаляем HTML-теги
        const textContent = htmlContent.replace(/<[^>]+>/g, '');
        // Обрезаем текст до 20 символов
        return textContent.length > 20 ? textContent.substring(0, 20) + '...' : textContent;
    };

    const content = getContentSnippet(post.content);

    // Загрузка данных при монтировании компонента
    useEffect(() => {
        if (!post?.id) return;
        fetchPostStatistic(post.id);
    }, [post]);

    const fetchPostStatistic = async (id) => {
        const data = await getPostStatistic(id);
        setPostStatistic(data);
    }

    return (
        <Card
            sx={{
                width: 345,
                height: 'auto',
                m: 1,
                ml: 0,
                border: 1,
                borderColor: 'grey.300',
                borderRadius: 1,
            }}
            elevation={0}
        >
            <CardActionArea sx={{height: '100%'}} onClick={() => navigate(route + '/' + post.id)}>
                {
                    post.image ? (
                        <CardMedia
                            component='img'
                            width='200'
                            height='170'
                            image={API_URL + '/static/' + post.image}
                        />
                    ) : (
                        <Box sx={{width: '200px', height: '170px', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
                            <Typography variant='body1' color='templateText.secondary' align='center' sx={{opacity: 0.5}}>
                                Без изображения
                            </Typography>

                        </Box>
                    )
                }

                <CardContent>
                    <Typography variant='body2' component={'span'} color='templateText.secondary'>
                        {post.branches?.map((branch) => (
                            <Chip
                                size='small'
                                color='info'
                                key={branch.name}
                                label={branch.name}
                                sx={{mr: 0.5}}
                            />
                        ))}
                    </Typography>

                    <Typography gutterBottom variant='h5' component='div'>
                        {post.title}
                    </Typography>
                    <Typography variant='body2' color='templateText.secondary'>
                        Автор: {post.user?.internalName || post.user?.name || post.authorInternalNameSnapshot || post.authorNameSnapshot || 'Неизвестно'}
                    </Typography>

                    <Typography variant='body2' color='templateText.secondary'>
                        {content}
                    </Typography>

                    {!post.exampleService && (
                        <Typography variant='body2' component={'div'} color='templateText.secondary'>
                            <Chip
                                size='small'
                                color={
                                    post.status == null || post.status === 0
                                        ? 'success'
                                        : post.status === 1
                                            ? 'primary'
                                            : post.status === 2
                                                ? 'error'
                                                : 'warning'
                                }
                                label={
                                    post.status == null || post.status === 0
                                        ? 'Опубликовано'
                                        : post.status === 1
                                            ? 'Сохранено'
                                            : post.status === 2
                                                ? 'В архиве'
                                                : 'Отложено'
                                }
                                sx={{my: 1}}
                            />
                        </Typography>
                    )}

                    {post.type === 'promotions' &&
                        <RequestAppointmentCounter count={postStatistic?.requestAppointmentCount}/>}

                    {post.exampleService && (
                        <Typography variant='body2' component={'span'} color='templateText.secondary'>
                            <Chip
                                size='small'
                                color='info'
                                label={post.exampleService.name}
                                sx={{ml: 0.5, mt: 0.5}}
                            />
                        </Typography>
                    )}
                </CardContent>
            </CardActionArea>
        </Card>
    )
        ;
};

export default PostItem;
